import { render } from "./ElectionRegisterView.vue?vue&type=template&id=0f1a7988"
import script from "./ElectionRegisterView.vue?vue&type=script&lang=js"
export * from "./ElectionRegisterView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__